document.addEventListener("DOMContentLoaded", () => {

  function slideDown(element, duration = 200) {
    // Make sure the element is visible (but hidden via styles for the animation)
    element.style.removeProperty('display');
    let computedDisplay = window.getComputedStyle(element).display;
    if (computedDisplay === 'none') computedDisplay = 'block';
    element.style.display = computedDisplay;
  
    // Get computed paddings before modifying styles
    const computedStyle = window.getComputedStyle(element);
    const targetPaddingTop = computedStyle.paddingTop;
    const targetPaddingBottom = computedStyle.paddingBottom;
  
    // Set initial styles: collapse height and paddings
    element.style.height = '0';
    element.style.paddingTop = '0';
    element.style.paddingBottom = '0';
    element.style.overflow = 'hidden';
  
    // Force a reflow so that the initial styles are applied
    element.offsetHeight;
  
    // Measure the full height of the element (content + paddings)
    const targetHeight = element.scrollHeight;
  
    // Apply a transition to height and paddings
    element.style.transition = `height ${duration}ms ease, padding-top ${duration}ms ease, padding-bottom ${duration}ms ease`;
    
    // Animate to the target values
    element.style.height = targetHeight + 'px';
    element.style.paddingTop = targetPaddingTop;
    element.style.paddingBottom = targetPaddingBottom;
  
    // Clean up after the animation completes
    window.setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('transition');
    }, duration);
  }
  
  function slideUp(element, duration = 200) {
    // Get computed styles and store paddings
    const computedStyle = window.getComputedStyle(element);
    const targetPaddingTop = computedStyle.paddingTop;
    const targetPaddingBottom = computedStyle.paddingBottom;
    
    // Set the element's explicit height and paddings in preparation for the animation
    element.style.height = element.offsetHeight + 'px';
    element.style.paddingTop = targetPaddingTop;
    element.style.paddingBottom = targetPaddingBottom;
    element.style.overflow = 'hidden';
  
    // Force a reflow to apply these explicit values
    element.offsetHeight;
  
    // Apply transition for height and paddings
    element.style.transition = `height ${duration}ms ease, padding-top ${duration}ms ease, padding-bottom ${duration}ms ease`;
  
    // Animate the element to height 0 and paddings 0
    element.style.height = '0';
    element.style.paddingTop = '0';
    element.style.paddingBottom = '0';
  
    // After the animation, hide the element and clean up inline styles
    window.setTimeout(() => {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('transition');
    }, duration);
  }
  
  function slideToggle(element, duration = 200) {
    if (window.getComputedStyle(element).display === 'none') {
      slideDown(element, duration);
    } else {
      slideUp(element, duration);
    }
  }
  
  const faq_questions = document.querySelectorAll(".homepage-faq__item__question");
  
  faq_questions.forEach(question => {
      question.addEventListener("click", () => {
          const parent = question.parentNode;
          slideToggle(parent.querySelector(".homepage-faq__item__answer"), 200);
      });
  });
});